<template>
    <div class="item_container" :style="'width:' + width/1920*100 + 'vw; height:' + height/1080*100 + 'vh;'">
        <div class="item_head">
            <div class="item_title">{{title}}</div>
            <div class="item_describe">{{describe}}</div>
        </div>
        <div class="item_content" :style="'height:' + (height - 60)/1080*100 + 'vh;'">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "item",
        props: ['width', 'height', 'title', 'describe']
    }
</script>

<style lang="less" scoped>
    .item_container {
        background: #fff;
        margin-right: 80/192vw;
        margin-bottom: 80/108vh;
        padding: 0 16rem;

        .item_head {
            .h(60);
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 8rem;

            .item_title {
                font-size: 18rem;
                color: #333;
                font-weight: bold;
            }

            .item_describe {
                font-size: 18rem;
                color: #666;
                font-weight: bold;
            }
        }

        .item_content {
            width: 100%;
        }
    }
</style>